/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReceiptDto { 
    id?: number;
    guid?: string;
    locationCode?: string | null;
    locationAddress?: string | null;
    locationName?: string | null;
    timeZoneId?: string | null;
    creationTime?: string;
    totalHours?: number;
    startDateTime?: string;
    endDateTime?: string;
    totalAmount?: number;
    vehicleRegistrationNo?: string | null;
    phoneNumber?: string | null;
    cardHolderName?: string | null;
    state_Province?: string | null;
    isSuccess?: boolean;
}

